import { render, staticRenderFns } from "./leave-form.vue?vue&type=template&id=5b2b2204&scoped=true"
import script from "./leave-form.vue?vue&type=script&lang=js"
export * from "./leave-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2b2204",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b2b2204')) {
      api.createRecord('5b2b2204', component.options)
    } else {
      api.reload('5b2b2204', component.options)
    }
    module.hot.accept("./leave-form.vue?vue&type=template&id=5b2b2204&scoped=true", function () {
      api.rerender('5b2b2204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/office/task/form/leave-form.vue"
export default component.exports